import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';

import { ChannelId } from '../../../../util/channels';

import { BotsCreators } from '../../../../store/actions/bots';
import { UserActions } from '../../../../store/actions/users';

import Toggle from '../../../Elements/Toggle';
import Footer from '../../../Footer2/index';

import ChannelWhatsappSendfySettings from './ChannelWhatsappSendfySettings';
import ChannelWhatsappWavySettings from './ChannelWhatsappWavySettings';

import './styles.scss';

const INITIAL_STATE_SETTINGS = {
  channelId: ChannelId.WhatsApp,
  settings: {
    whatsapp_provider: 'sendfy',
    number: '',
    campaign: '',
    username: '',
    password: '',
    authenticationToken: '',
  },
  isActive: false,
};

function ChannelWhatsApp(props) {
  const { bot, match, retrieveBotRequest, updateBotRequest, i18n, user } =
    props;

  const [whatsappSettings, setWhatsappSettings] = useState(
    INITIAL_STATE_SETTINGS
  );

  const [isNewChannel, setIsNewChannel] = useState(true);

  const channels = bot.channels || [];
  const botid = match?.params?.botid;

  useEffect(() => {
    if (botid) {
      retrieveBotRequest(botid);
    }
  }, [botid]);

  useEffect(() => {
    if (bot && bot.channels) {
      const config = bot.channels.find(
        (channel) => channel.channelId === 'WhatsApp'
      );

      if (config?.settings?.whatsapp_provider) {
        setWhatsappSettings({
          ...INITIAL_STATE_SETTINGS,
          settings: {
            ...config.settings,
            whatsapp_provider: config.settings.whatsapp_provider,
          },
          isActive: config.isActive,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (bot) {
      const findWhatsappChannel = channels.find(
        (channel) => channel.channelId === ChannelId.WhatsApp
      );

      if (findWhatsappChannel) {
        setWhatsappSettings(findWhatsappChannel);
        setIsNewChannel(false);
      }
    }
  }, [channels]);

  function handleInputChange(event) {
    const { name, value } = event.target;
    const { settings } = whatsappSettings;

    setWhatsappSettings({
      ...whatsappSettings,
      settings: { ...settings, [name]: value },
    });
  }

  function handleStatusChange() {
    setWhatsappSettings({
      ...whatsappSettings,
      isActive: !whatsappSettings.isActive,
    });
  }

  function handleSelectProviderChange(event) {
    const { isActive } = whatsappSettings;

    const findWhatsappChannel = channels.find(
      (channel) => channel.channelId === ChannelId.WhatsApp
    );

    if (findWhatsappChannel) {
      setWhatsappSettings({
        ...INITIAL_STATE_SETTINGS,
        settings: {
          ...findWhatsappChannel.settings,
          whatsapp_provider: event.target.value,
        },
        isActive,
      });
    } else {
      const { settings } = INITIAL_STATE_SETTINGS;
      setWhatsappSettings({
        ...INITIAL_STATE_SETTINGS,
        settings: {
          ...settings,
          whatsapp_provider: event.target.value,
        },
        isActive,
      });
    }
  }

  function isValidSendfySettings() {
    const { number, campaign, username, password } = whatsappSettings.settings;

    if (!number || number.length >= 14 || number.length <= 10) {
      toastr.error('Erro', 'Preencha o número corretamente ');
      return false;
    }
    if (!campaign) {
      toastr.error('Erro', 'Campanha inválida');
      return false;
    }
    if (!username) {
      toastr.error('Erro', 'Usuário inválido');
      return false;
    }
    if (!password) {
      toastr.error('Erro', 'Senha inválida');
      return false;
    }

    return true;
  }

  function isValidWavySettings() {
    const { username, authenticationToken } = whatsappSettings.settings;

    if (!username) {
      toastr.error('Erro', 'Usuário inválido');
      return false;
    }
    if (!authenticationToken) {
      toastr.error('Erro', 'Token de autenticação inválido');
      return false;
    }

    return true;
  }

  function isValidSettings() {
    const { whatsapp_provider } = whatsappSettings.settings;

    if (whatsapp_provider === 'wavy') {
      return isValidWavySettings();
    }
    return isValidSendfySettings();
  }

  function handleUpdateChannel() {
    if (!isValidSettings()) return;

    let updatedChannels = [];

    if (isNewChannel) {
      updatedChannels = [...channels, whatsappSettings];
    } else {
      updatedChannels = channels.map((channel) =>
        channel.channelId === ChannelId.WhatsApp ? whatsappSettings : channel
      );
    }

    if (whatsappSettings.settings.whatsapp_provider === 'sendfy') {
      updateBotRequest(botid, { channels: updatedChannels }, true, true, true);
    } else {
      updateBotRequest(botid, { channels: updatedChannels }, true, true, false);
    }

    setIsNewChannel(false);
  }

  if (!bot?._id) return null;

  return (
    <div className="channelWhats-container">
      <div className="col-md-6 mt-5">
        <span className="channel-title">{i18n.t('Configurar WhatsApp')}</span>
        <div className="channel-whatsapp mt-2">
          <select
            name="whatsapp_provider"
            value={whatsappSettings.settings.whatsapp_provider}
            onChange={handleSelectProviderChange}
            className="form-group__input-select"
          >
            <option value="sendfy">Sendfy</option>
            <option value="wavy">Wavy</option>
          </select>

          {whatsappSettings?.settings?.whatsapp_provider === 'wavy' ? (
            <ChannelWhatsappWavySettings
              botId={bot?._id}
              wavySettings={whatsappSettings.settings}
              user={user}
              onChange={handleInputChange}
            />
          ) : (
            <ChannelWhatsappSendfySettings
              sendfySettings={whatsappSettings.settings}
              user={user}
              onChange={handleInputChange}
            />
          )}

          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <Toggle
                disabled={
                  !!(user && user.selectedCompany?.claim?.name === 'Viewer')
                }
                name=""
                checked={whatsappSettings.isActive}
                onChange={() => handleStatusChange()}
              />
              <div style={{ marginTop: 8, width: 200 }}>
                <span>{i18n.t('Ativar canal')}</span>
              </div>
            </div>

            <button
              disabled={
                !!(user && user.selectedCompany?.claim?.name === 'Viewer')
              }
              className="btn btn-primary mt-3"
              onClick={() => handleUpdateChannel()}
              type="button"
            >
              {i18n.t('salvar')}
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelWhatsApp))
);
